<template>
  <div v-if="opportunity">
    <v-toolbar class="transparent elevation-0 my-3">
      <div class="headline">Managers</div>
      <v-spacer />
      <can I="edit" a="Opportunity">
        <v-dialog v-model="adding" max-width="600px">
          <v-btn round slot="activator" color="secondary">
            <v-icon>mdi-plus</v-icon> Add Manager
          </v-btn>

          <v-card dark>
            <v-card-title>
              <div>
                <div class="title">Add a Manager</div>
                <div class="subtitle grey--text">Click a client to add</div>
              </div>
              <v-spacer />
              <v-btn flat icon @click="adding = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider />
            <v-card-text v-if="unassigned.length">
              <v-chip
                v-for="client in unassigned"
                :key="`add-manager-${client.id}`"
                @click="add(client)"
              >
                <v-avatar
                  ><img :src="client.avatar || '/img/missing/avatars/original.png'"
                /></v-avatar>
                {{ client.firstNames }} {{ client.lastName }}
              </v-chip>
            </v-card-text>
            <v-card-text v-else>
              All clients are assigned or there are none.
            </v-card-text>
          </v-card>
        </v-dialog>
      </can>
    </v-toolbar>

    <v-card dark v-if="managers.length">
      <v-list>
        <v-list-tile avatar v-for="manager in managers" :key="`manager-${manager.id}`">
          <v-list-tile-avatar>
            <v-avatar size="32px">
              <img :src="manager.avatar || '/img/missing/avatars/original.png'" />
            </v-avatar>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title> {{ manager.fullName }} </v-list-tile-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <can I="edit" a="Opportunity">
              <v-menu left>
                <v-btn icon flat slot="activator" color="error">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
                <v-card>
                  <v-card-title>Remove {{ manager.fullName }}?</v-card-title>
                  <v-card-actions>
                    <v-btn block color="error" @click="remove(manager.id)">
                      Remove
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </can>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-card>
  </div>
</template>

<script>
// Helpers
import { mapGetters } from 'vuex'
import _ from 'lodash'

// Vue Component
export default {
  created() {
    this.$store.dispatch('admin/clients/fetchAll')
  },
  data() {
    return {
      adding: false,
    }
  },
  computed: {
    opportunity() {
      return this.$store.getters['admin/opportunities/find']()
    },
    ...mapGetters({
      clients: 'admin/clients/all',
    }),
    managers() {
      return this.opportunity.managers || []
    },
    unassigned() {
      if (!_.get(this.opportunity, 'organization.id')) return []
      const managers = (this.managers || []).map(x => x.id)
      return this.clients.filter(client => {
        return (
          !client.disabledAt &&
          client.organization.id === this.opportunity.organization.id &&
          managers.indexOf(client.id) < 0
        )
      })
    },
  },
  methods: {
    add(client) {
      this.opportunity.managers.push(client)
      this.$store.dispatch('admin/opportunities/update', this.opportunity)
    },
    remove(id) {
      this.$store.dispatch(
        'admin/opportunities/update',
        Object.assign({}, this.opportunity, {
          managers: this.opportunity.managers.filter(m => m.id !== id),
        })
      )
    },
  },
}
</script>
